import { useContext, useEffect, useRef } from 'react'

import context from './context'

const NavigationSection = ({ children, title, id, ...rest }) => {
  const { sections, registerSection } = useContext(context)
  const ref = useRef()
  const storedTitle = useRef()

  useEffect(() => {
    if (
      sections.findIndex(item => item.title === title) !== -1 ||
      !ref ||
      !ref.current
    ) {
      storedTitle.current = title
      return
    }

    registerSection(title, ref.current, storedTitle.current, id)
  }, [registerSection, title, sections, ref, id])

  return (
    <div {...rest} id={title} ref={ref}>
      {children}
    </div>
  )
}

export default NavigationSection
